module.exports = __webpack_public_path__ + "img/09.f0029af2.jpg";